export const PROD = 'prod'
export const STAGE = 'stage'
export const MASTER = 'master'
